import React, { useState, useRef, useEffect } from 'react';
import { ambulanceServices } from '../../data/ambulanceServices';
import { FadeInFromBottomSection } from '../../utils/ServicePageFadeEffects';
import { FaInfoCircle } from 'react-icons/fa';

export default function OurServicesCardForServicePage() {
  const services = ambulanceServices;
  const [expanded, setExpanded] = useState(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

  return (
    <FadeInFromBottomSection className="relative -mt-4 sm:-mt-16 lg:-mt-20 pt-8 pb-16 min-h-screen max-w-6xl mx-4 sm:mx-6 md:mx-4 lg:mx-auto px-6 sm:px-6 md:px-10 backdrop-blur-[32px] bg-white bg-opacity-70 rounded-xl shadow-md font-sans select-none">

      <h1 className="text-4xl font-bold text-sky-600 mb-12 text-center font-heading">Our Services</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {services.map((svc, idx) => (
            <div
              key={svc.title}
              className="min-w-[260px] sm:min-w-[300px] h-[480px] flex-shrink-0 bg-white bg-opacity-70 rounded-2xl border shadow-lg flex flex-col justify-end relative text-center p-4 select-none cursor-pointer"
              tabIndex={0}
              style={{
                scrollSnapAlign: "center",
                backgroundImage: svc.image ? `url('${svc.image}')` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              onMouseEnter={() => !isMobile && setExpanded(idx)}
              onMouseLeave={() => !isMobile && setExpanded(null)}
              onClick={() => isMobile && setExpanded(expanded === idx ? null : idx)}
            >
              <div className="absolute inset-x-0 bottom-0 pb-4  flex justify-center">
                <div className={`w-[230px] sm:w-[253px] bg-white bg-opacity-95 rounded-xl shadow 
                  text-center flex flex-col items-center justify-center border-2 border-yellow-300 
                  services-card-overlay${expanded === idx ? " expanded" : ""}`}>
                  <div className="text-4xl mb-2 mt-4 flex justify-center items-center">{svc.icon}</div>
                  <div className="text-lg mb-4 font-bold text-sky-700 leading-tight">{svc.title}</div>
                  <div className="text-sm mb-2 text-gray-400 leading-tight flex gap-2 items-center justify-center lg:hidden">
                    <FaInfoCircle className=" flex" />
                    <span className='flex'>Click for more info</span>
                  </div>
                  <div className={`transition-opacity duration-300 
                    ${expanded === idx ? "opacity-100 mt-4" : "opacity-0 h-0 mt-0 overflow-hidden"}`}>
                    {svc.badge && (
                      <div className="text-sm font-semibold text-amber-600 mb-1 ">{svc.badge}</div>
                    )}
                    <div className="text-gray-600 text-[14px] px-2 mb-2 ">{svc.description}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </FadeInFromBottomSection>
  )
}
